import React from 'react';
import Navbar from './global-components/navbar';
import Error from './section-components/error';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const ErrorPage = () => {
    return <div>
        <Navbar />
        <Error />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default ErrorPage

